import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Add retry configuration for network failures
    retryAttempts: 3,
    retryDelay: 1000
  },
  global: {
    // Add custom fetch with timeout and retry logic
    fetch: async (url, options = {}) => {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller?.abort(), 10000); // 10s timeout
      
      try {
        const response = await fetch(url, {
          ...options,
          signal: controller?.signal
        });
        clearTimeout(timeoutId);
        return response;
      } catch (error) {
        clearTimeout(timeoutId);
        // Log network errors for debugging
        console.error('Supabase fetch error:', error?.message);
        throw error;
      }
    }
  },
  db: {
    schema: 'public'
  },
  // Disable realtime for better stability during database issues
  realtime: {
    params: {
      eventsPerSecond: 2
    }
  }
});